import { ViewportScroller } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { BlockUIModule } from 'ng-block-ui';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [BlockUIModule, RouterOutlet]
})
export class AppComponent implements OnInit {
  title = 'addtix';

  ngOnInit() {
    // ponytail: single vanity host, hardcoded like the checks in integration.service.ts.
    // Move to a hostname->slug map in environment.ts if a third one shows up.
    // skipLocationChange keeps the short URL in the address bar.
    if (window.location.hostname === 'jumboadventurun.addtix.id' && window.location.pathname === '/') {
      this.router.navigateByUrl('/event/jumbo-adventurun', { skipLocationChange: true });
    }
  }

  constructor(private router: Router, private viewportScroller: ViewportScroller) {
    // Subscribe to the NavigationEnd event to reset scroll position on navigation
    // this.router.events.subscribe((event) => {
    //   if (event instanceof NavigationEnd) {
    //     // When the NavigationEnd event occurs, reset the scroll position to the top
    //     this.viewportScroller.scrollToPosition([0, 0]);
    //   }
    // });
  }
}
